import React, {useEffect} from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom';
import GettingData from '../views/GettingData/GettingData';
import LoginPage from '../views/LoginPage';
import ProtectedRoute from './ProtectedRoute';
import { LoginServices } from '../services/LoginServices';
import Dashboard from "../views/Dashboard/Dashboard";
import Reports from "../views/Reports/Reports";
import References from "../views/References/References";
import Gaps from "../views/AssistanceGaps/Gaps";
import {LogsServices} from "../services/LogsServices";
import ViewLogs from "../views/ViewLogs/ViewLogs";

function RouterLogger() {
  const location = useLocation();
  const prevLocationRef = React.useRef(null);
  useEffect(() => {
    if(prevLocationRef.current && prevLocationRef.current !== location.pathname) {
      LogsServices.postLog(`Navegação: Troca de rota para ${location.pathname}`);
    }
    prevLocationRef.current = location.pathname;
  }, [location]);
}

function RoutesIndex() {

  return (
    <BrowserRouter>
      <RouterLogger />
      <Routes>
        <Route path="/login" element={LoginServices.verifySession() ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/getting-data" element={<GettingData />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/gaps" element={<Gaps />} />
          <Route path="/net-sizing" element={<div className='w-full h-full flex items-center justify-center'>Dimensionamento de rede</div>} />
          <Route path="/references" element={<References />} />
          <Route path="/logs" element={<ViewLogs />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default RoutesIndex;